export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            initOnRender: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn btn-primary",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'export'
            },
        ],
        headerFields: [
            {
                name: "patientName",
                label: "Beutalt páciens",
                visibility: true
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "Páciens TAJ száma",
                visibility: true
            },
            {
                name: "patientTelephoneNumber",
                label: "Páciens telefonszáma",
                visibility: true
            },
            {
                name: "internalReferralId",
                label: "Beutaló sorszáma",
                visibility: true
            },
            {
                name: "doctorName",
                label: "Beutaló orvos",
                visibility: true
            },
            {
                name: "organizationUnitName",
                label: "Beutaló szakma",
                visibility: true
            },
            {
                name: "treatmentName",
                label: "Kért vizsgálat",
                visibility: true
            },
            {
                name: "referralDate",
                label: "Beutalás ideje",
                visibility: true
            },
            {
                name: "referralStatus",
                label: "Felhasználva",
                visibility: true
            },
        ],
    }
 }